"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

exports.default = function () {
    var wrappingSelector = '.alternative-pickup-place';
    var order = void 0;

    if (!_common2.default.setListenerSafe(wrappingSelector + " #evaluateOrderDetails", evaluateClick)) return;

    var ppService = abp.services.api.pickupPlace;

    _common2.default.setListenerSafe(wrappingSelector + " #newPickupPlace", showPickupPlaceDialog);
    _common2.default.setListenerSafe(wrappingSelector + " #confirmNewPickupPlace", confirmNewPickupPlace);

    function switchSteps() {
        hideShowSection('#pickupPlaceStep1');
        hideShowSection('#pickupPlaceStep2');
    }

    function evaluateClick() {
        var OrderNumber = _common2.default.getElementPropertySafe(wrappingSelector + " .orderNumberInput");
        var Email = _common2.default.getElementPropertySafe(wrappingSelector + " .emailInput");
        var PhoneNumber = _common2.default.getElementPropertySafe(wrappingSelector + " .phoneNumberInput");

        ppService.evaluateOrder({ OrderNumber: OrderNumber, Email: Email, PhoneNumber: PhoneNumber }).done(function (result) {
            if (!result || result.returnType !== 1) {
                var messageText = result.returnType === 2 ? Resx.Messages.AlternativePickupPlaceAlreadySelected : Resx.Messages.OrderNotFound;
                _message2.default.error(messageText);
                return;
            }
            order = result;
            _common2.default.setElementPropertySafe(wrappingSelector + " #currentPickupPlace", 'textContent', result.currentPickupPlace.name);
            switchSteps();
        }).fail(function (e) {
            console.error(e);
            _message2.default.error(Resx.Messages.OrderNotFound);
        });
    }

    function hideShowSection(selectorPart) {
        var element = document.querySelector(wrappingSelector + " " + selectorPart);
        if (!element) return;

        if (element.classList.contains('hidden')) element.classList.remove('hidden');else element.classList.add('hidden');
    }

    function showPickupPlaceDialog() {
        var country = _utils2.default.skEnvironment() ? 'sk' : 'cz';
        Packeta.Widget.close();
        Packeta.Widget.pick(packetaApiKey, pickupPlaceHandler, {
            country: country,
            language: _utils2.default.skEnvironment() ? 'sk' : 'cs'
        });
    };

    function pickupPlaceHandler(point) {
        if (!point || !point.id) {
            _common2.default.setElementPropertySafe(wrappingSelector + " #confirmNewPickupPlace", 'disabled', true);
            return;
        }

        _common2.default.setElementPropertySafe(wrappingSelector + " #newPickupPlace", 'textContent', point.name);
        order.newPickupPlace = { reference: point.id, name: point.name /*, Description: point.url */ };
        _common2.default.setElementPropertySafe(wrappingSelector + " #confirmNewPickupPlace", 'disabled', false);
    }

    function confirmNewPickupPlace(button) {
        button.disabled = true;
        ppService.setAlternativePickupPlace(order).done(function (result) {
            button.disabled = false;
            if (!result) {
                _message2.default.error(Resx.Common.AjaxError);
                return;
            }

            switch (result.statusType) {
                case 0:
                    hideShowSection('#pickupPlaceStep2');
                    hideShowSection('#pickupPlaceCaption');
                    hideShowSection('#pickupPlaceStep3');
                    break;
                case 1:
                    _message2.default.warn(result.statusMessage);
                    break;
                case 2:
                    _message2.default.error(result.statusMessage);
                    break;
            }
        }).fail(function (e) {
            button.disabled = false;
            console.error(e);
            _message2.default.error(Resx.Common.AjaxError);
        });
    }
    /* Alternative solution using MVC controller instead of Abp and Web.Api  */
    function setAlternativePickupPlace(order) {
        var httpRequest = new XMLHttpRequest();
        httpRequest.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                console.log(httpRequest);
            }
        };
        httpRequest.open("POST", "/Order/SetNewPickupPlace", true);
        httpRequest.setRequestHeader('Content-type', 'application/json; charset=UTF-8');

        var xsrfToken = _cookie2.default.getCookie('XSRF-TOKEN');
        httpRequest.setRequestHeader('X-XSRF-TOKEN', xsrfToken);
        httpRequest.send((0, _stringify2.default)(order));
    }
};

var _utils = require("../cart/components/utils");

var _utils2 = _interopRequireDefault(_utils);

var _common = require("../common");

var _common2 = _interopRequireDefault(_common);

var _message = require("linksoft/message");

var _message2 = _interopRequireDefault(_message);

var _cookie = require("linksoft/utils/cookie");

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/alternativePickupPlace.js
// module id = 1054
// module chunks = 1